import { EEinvoicingStatus } from '@Arti-zen/package-backoffice'
import { colorByState } from '../EinvoicingTable.definitionFields'
import { Stack, ToggleButton, ToggleButtonGroup } from '@mui/material'
import { useCallback } from 'react'

type TProps = {
  statusList: Partial<Record<EEinvoicingStatus, number>> | null
  filters: EEinvoicingStatus[]
  setFilters: React.Dispatch<React.SetStateAction<EEinvoicingStatus[]>>
}

export function StatusListSelect({ statusList, filters, setFilters }: TProps) {
  const handleChange = useCallback(
    (_: unknown, newFilters: EEinvoicingStatus[]) => {
      setFilters(newFilters)
    },
    [setFilters]
  )

  if (!statusList || Object.keys(statusList).length === 0) return null

  return (
    <Stack mb={3}>
      <ToggleButtonGroup value={filters} onChange={handleChange} size="small">
        {(Object.entries(statusList) as [EEinvoicingStatus, number][]).map(([state, count]) => {
          const color = colorByState[state]

          return (
            <ToggleButton
              key={state}
              value={state}
              sx={{
                textTransform: 'none',
                fontWeight: 600,
                borderRadius: 3,
                border: `1px solid ${color}`,
                color: color,
                px: 2,
                transition: 'all 0.2s ease',
                '&.Mui-selected': {
                  backgroundColor: color,
                  color: '#fff',
                  '&:hover': {
                    backgroundColor: color,
                  },
                },
              }}
            >
              {state} ({count})
            </ToggleButton>
          )
        })}
      </ToggleButtonGroup>
    </Stack>
  )
}
